$(document).ready(function(){
    var form = $('form#operation-form');
    if ( window.location.hash == "#documentModal")
        $('#documentModal').modal({show: true})


    $('#km_compteur').keyup(function(){
        checkKmCompteur();
        var numChaissis = $('#numChassis').val();

        if (numChaissis) {
            $.post(rootUrl+'operations/checkKmOperation', {numChassis: numChaissis}).done(function(data) {
                var callBack = $.parseJSON(data);

                checkLastKmCompteur(callBack.km);
            });
        }
    });

    initUploadDocumentFormValidate();
    initSearchContract(rootUrl);
    initPieceCausaleAutocomplete(rootUrl, form);
    initCodeDefautAutocomplete(rootUrl, form);
    initInputListener(form);
    initFormSelectListener(form);
    initSuppressionOperationListener(rootUrl);
    initOperationFormValidate(form);
});

function initInputListener(form){
    initInputCss(form);
    form.on("change", "input", function(){
        if($(this).val() != ""){
            $(this).css('background-color', '#FFF');
        }
        else{
            $(this).css('background-color', '#F9F9F9');
        }
    });
}

function initPieceCausaleAutocomplete(rootUrl, form){
    $("[name=pieceCausale]").autocomplete({
        source: rootUrl+'operations/organes',
        minLength: 2,
        change: function(event, ui){
            initInputCss(form);
        }
    })
}

function initInputCss(form){
    form.find("input").each(function(){
        if($(this).val() != "" && !$(this).prop('disabled')){
            $(this).css('background-color', '#FFF');
        }
        else{
            $(this).css('background-color', '#F9F9F9');
        }
    });
}

function initSearchContract(rootUrl){
    $('#numChassis').on("keyup change", function(){
        var numChassis = $(this).val();
        $.ajax({
           type:'GET',
           url: rootUrl+'operations/searchContract',
           data: { numChassis: numChassis },
           async: true,
           dataType: 'text',
           contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
           beforeSend:function(xhr){
               xhr.overrideMimeType('text/html;charset=UTF-8');
           },
           success:function(data, textStatus){
                $('#panelContrats').html(data);
                checkKmCompteur();
           },
           error:function(xhr, textStatus, thrownError){
               alert('Erreur AJAX : '+thrownError);
           }
        });
    });
}

function initFormSelectListener(form){
    $('#concessionnaire').change(function(){
        if($(this).val() == "Autre"){
            var inputs = '<div class="form-group">'+
                            '<label for="nom_concessionnaire" class="required">Nom concessionnaire</label>'+
                            '<input type="text" class="form-control" id="nom_concessionnaire" name="nomConcessionnaire" placeholder="Nom du concessionnaire réparateur" required="required">'+
                         '</div>'+
                         '<div class="form-group">'+
                            '<label for="adresse_concessionnaire">Adresse concessionnaire</label>'+
                            '<input type="text" class="form-control" id="adresse_concessionnaire" name="adresseConcessionnaire" placeholder="Adresse du concessionnaire réparateur">'+
                         '</div>'+
                         '<div class="form-group">'+
                            '<label for="mail_concessionnaire">Email concessionnaire</label>'+
                            '<input type="email" class="form-control" id="mail_concessionnaire" name="mailConcessionnaire" placeholder="Mail du concessionnaire réparateur">'+
                         '</div>'+
                         '<div class="form-group">'+
                            '<label for="tel_concessionnaire">Téléphone concessionnaire</label>'+
                            '<input type="text" class="form-control" id="tel_concessionnaire" name="telConcessionnaire" placeholder="Téléphone du concessionnaire réparateur">'+
                         '</div>';

            $('#nouveau-concessionnaire').html(inputs);
            initInputCss(form);
        }
        else{
            $('#nouveau-concessionnaire').html('');
        }
    });
}

function initCodeDefautAutocomplete(rootUrl, form){
    $("#codeDefaut").autocomplete({
        source: rootUrl+'operations/codesDefaut',
        minLength: 2,
        change: function(event, ui){
            initInputCss(form);
        }
    });
}

function checkKmCompteur(){
    if(parseFloat($('#km_compteur').val()) > parseFloat($('[name=kmMaxCalculeMaxi]').val()) && parseFloat($('[name=kmMaxCalculeMaxi]').val()) != 0){
        $('#warningKmCompteurSuperieur').removeClass('hide');
    } else {
        $('#warningKmCompteurSuperieur').addClass('hide');
    }
}

function checkLastKmCompteur(LastKmCompteur){
    if(parseFloat($('#km_compteur').val()) <= parseFloat(LastKmCompteur) && parseFloat(LastKmCompteur) != 0){
        $('#warningKmCompteurInferieur').removeClass('hide');
    } else {
        $('#warningKmCompteurInferieur').addClass('hide');
    }
}

function initSuppressionOperationListener(rootUrl){
    $('#btn-supprimer-operation').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer cette opération ?");
        if(verif){
            var operationId = $('#operationId').val();
            $.ajax({
                type:'GET',
                url: rootUrl+'operations/supprimerOperation',
                data: { operationId: operationId },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    document.location.href=rootUrl+'operations';
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
}

function dayDiff(d1, d2)
{
    d1 = d1.getTime() / 86400000; // 86400000 : nombre de millisecondes dans une journée
    d2 = d2.getTime() / 86400000;
    var diff = d2 - d1;
    return diff.toFixed(0);
}

function initOperationFormValidate(form){

    $.validator.addMethod("dateGreaterThan", function(value, element, params) {
        return new Date(value) >= new Date($(params).val());
    });

    $.validator.addMethod("dateInLast3Months", function(value, element){
        var today = new Date();
        var splittedDate;
        var dateOperation;
        if(value.indexOf("/") != -1){ // Si la chaîne contient un "/", on splitte (compatibilité Internet Explorer)
            splittedDate = value.split("/");
            dateOperation = new Date(splittedDate[2], splittedDate[1]-1, splittedDate[0]); // -1 : JavaScript compte les mois de 0 à 11, Janvier : 0, Décembre : 11
        } else {
            splittedDate = value.split("-");
            dateOperation = new Date(splittedDate[0], splittedDate[1]-1, splittedDate[2]); // -1 : JavaScript compte les mois de 0 à 11, Janvier : 0, Décembre : 11
        }

        if($("#operationId").length && dayDiff(dateOperation, today) >= 0){ // Si modification d'une opération déjà existant, la date peut être antérieure de plus de 3 mois.
            return true;
        }

        return (dayDiff(dateOperation, today) < 90 && dayDiff(dateOperation, today) >= 0);
    });

    $.validator.addMethod("dateIsValid", function(value, element){

        var tempDate, jour, mois, annee;

        if(value.indexOf("/") >= 0) {
            tempDate = value.split("/");
            jour = parseInt(tempDate[0]);
            mois = parseInt(tempDate[1]);
            //annee = parseInt(tempDate[2]);
        }
        else {
            tempDate = value.split("-");
            jour = parseInt(tempDate[2]);
            mois = parseInt(tempDate[1]);
            //annee = parseInt(tempDate[0]);
        }
        if(mois > 0 && mois <= 12){
            if(mois == 1 || mois == 3 || mois == 5 || mois == 7 || mois == 8
                || mois == 10 || mois == 12){
                if(jour > 31 || jour < 1){
                    return false;
                }
            }
            else if (mois == 2){
                if(jour > 29 || jour < 1){
                    return false;
                }
            }
            else {
                if(jour > 30 || jour < 1){
                    return false;
                }
            }
        }
        else {
            return false;
        }
        return true;
    });

    $.extend($.validator.messages, {
        required: "Veuillez renseigner ce champ",
        email: "Veuillez saisir un email valide",
        number: "Veuillez saisir un nombre valide",
        date: "Veuillez saisir une date valide",
        dateIsValid: "Veuillez saisir une date valide!",
        dateInLast3Months: "Cette date ne peut pas être antérieure de plus de 3 mois ou postérieure à la date du jour",
        dateGreaterThan: "La date de déclaration doit être supérieure ou égale à la date de l'opération"
    });

    form.validate({
        onkeyup: false,
        onfocusout: false,
        errorElement: "div",
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        rules: {
            "numChassis": {
                required: true
            },
            "pays": {
                required: true,
                maxlength: 45
            },
            "concessionnaire": {
                required: true
            },
            "dateDeclaration": {
                required: true,
                date: true,
                dateIsValid: true,
                dateInLast3Months: true,
                dateGreaterThan: "#date_operation"
            },
            "dateOperation": {
                required: true,
                date: true,
                dateIsValid: true,
                dateInLast3Months: true
            },
            "kmCompteur": {
                required: true
            },
            "pieceCausale": {
                required: $('#pieceCausale').attr('data-required')
            },
            "nomConcessionnaire": {
                required: true
            },
            "mailConcessionnaire": {
                email: true
            }
        },
        messages: {
            "pays": {
                maxlength: "Veuillez ne pas dépasser 45 caractères"
            }
        }
    });
}

function initUploadDocumentFormValidate(){

    $.validator.addMethod("validFormat", function(value, element){
        var extension = value.split('.')[1];
        extension = extension.toLowerCase();
        return (extension == "doc" || extension == "docx" || extension == "odt" || extension == "ods" || extension == "xls" || extension == "xlsx" || extension == "pdf" || extension == "jpg" ||
        extension == "jpeg" || extension == "png" || extension == "csv" || extension == "ppt" || extension == "pptx" || extension == "odp" || extension == "txt");
        // Si le format de fichier est parmi ceux ci-dessus, return true, sinon return false.
    });

    $.extend($.validator.messages, {
        required: "Veuillez renseigner ce champ",
        validFormat: "Format de fichier non supporté"
    });

    $('#uploadForm').validate({
        onkeyup: false,
        onfocusout: false,
        errorElement: "div",
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        rules: {
            "docToUpload": {
                required: true,
                validFormat: true
            }
        }
    });
}